import { Location } from '@angular/common';
import { Component, HostListener, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CropperSettings, ImageCropperComponent } from 'ng2-img-cropper';
import { Observable } from 'rxjs/Observable';
import { setTimeout } from 'timers';
import * as _ from 'underscore';
import { CropImageComponent } from '../imageCropper/imageCropper';
import { Auth } from '../shared/services/auth';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { SharedData } from '../shared/sharedData';
import { ToasterComponent } from '../toasterComponent/toasterComponent';

@Component({
  selector: 'AddEmployees',
  templateUrl: 'addEmployees.html',
})

export class AddEmployeesComponent {
  public maxDate = { year: null, month: null, day: null };
  public minDate = { year: null, month: null, day: null };
  public _baseUrl: any;
  public gradeData: any = [];
  public orgData: any = [];
  public designationData: any = [];
  public managementLevelData: any = [];
  public isSecondarySupervisorRequired: any = false;
  public currentEmployee: any;
  public type: any = 'ADD';
  public oldValue = null;
  public oldOrgID: any;
  public empdisplayName: String = '';
  public verDisplayName: String = '';
  public secSupDisplayName: String = null;
  public catName: String = '';
  public managementName: String = '';
  public designationName: String = '';
  public gradeName = '';
  public orgName = '';
  public dynamicId: any;
  public disableSave: boolean = true;
  // image related variables
  public cropperSettings: CropperSettings;
  public data: any;
  public isUpdateImage: any = false;
  public orgFormData = null;
  @ViewChild('cropper', undefined)
  public cropper: ImageCropperComponent;

  // employee data
  public employeeId: any;
  public closeResult: string;

  public primarySupervisorModel: any = {
    id: null,
    displayName: ''
  };

  public secondarySupervisorModel: any = [{
    id: null,
    displayName: ''
  }];

  public verifierModel: any = {
    id: null,
    displayName: ''
  };

  public categoryModel: any = {
    id: null,
    type: ''
  };

  public gradeModel: any = {
    id: null,
    name: ''
  };

  public organizationModel: any = {
    id: null,
    orgName: ''
  };

  //changing object from any to Object to use ng model effectivly 
  public designationModel: any = {
    id: null,
    name: ''
  };

  public managementModel: any = {
    id: null,
    name: ''
  };

  public oldEmpSupData: any;

  public joiningDate: {
    year: number,
    month: number,
    day: number
  };

  public dateOfBirth: {
    year: number,
    month: number,
    day: number
  };

  public warning: any = 'Please type to select';

  public showButtonLoading: any = false;

  public payload = {
    searchString: '',
    excludeEmpIds: []
  };

  // this is going to be final PayLoad for save call
  public employeeData = {
    id: null,
    firstName: null,
    lastName: null,
    middleName: null,
    displayName: null,
    userName: null,
    email: null,
    empCode: null,
    status: 'ACTIVE',
    image: null,
    imageHeight: null,
    imageWidth: null,
    fileExtension: null,
    joiningDate: null,
    gradeId: null,
    gradeName: null,
    managementLevelId: null,
    managementLevelName: null,
    designationId: null,
    designationName: null,
    categoryId: null,
    categoryName: null,
    orgId: null,
    primarySupervisorId: null,
    verifierId: null,
    secSupervisorIds: [],
    imageUrl: null,
    orgName: null,
    licenceNumber: null,
    dateOfBirth: null,
    phoneNumber: null,
    gender: null,
    userRole: null
  };

  public errorMsg = {
    USER_NAME_EXISTS: 'User name already exists',
    EMAIL_EXISTS: 'Email id already exists',
    EMPCODE_EXISTS: 'Employee code already exists',
  };

  public loading: boolean = true;

  public roles: any = [
    'ROLE_USER', 'ROLE_VACCINE_ADMIN',
    'ROLE_VACCINE_SEARCH_ADMIN', 'ROLE_LAB_ADMIN', 'ROLE_TRACE_HUB_ADMIN'];

  constructor(
    public route: ActivatedRoute,
    public modalService: NgbModal,
    public _global: Configuration,
    public http: HttpClientCustom,
    public _sanitizer: DomSanitizer,
    public builder: FormBuilder,
    public _auth: Auth,
    public router: Router,
    public translate: TranslateService,
    public _location: Location,
    public share: SharedData,
    public _toaster: ToasterComponent, vcr: ViewContainerRef
  ) {
    this._baseUrl = _global.get('EPMS_BASE_URL');
    let data: any = this.share.getData();
    this._toaster.setViewRef(vcr);
    if (_.isEmpty(data)) {
      this._location.back();
    }
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; // January is 0!
    let yyyy = today.getFullYear();
    this.maxDate.day = dd;
    this.maxDate.month = mm;
    this.maxDate.year = yyyy;
    this.minDate.day = 1;
    this.minDate.month = 1;
    this.minDate.year = 1900;
    if (data.type === 'ADD') {
      this.currentEmployee = JSON.parse(localStorage.getItem('userInfo'));
      this.employeeId = this.currentEmployee.employeeId;
      this.generateEmployeeCode();
      this.loading = false;
    }
    if (data.type === 'EDIT' || data.type === 'ACTIVATE') {
      this.employeeId = data.employeeId;
      this.type = data.type;
      this.getEmployeeById();
    }
    this.data = {};
  }

  // temporary fixes for cal close
  public openDatePicker(id) {
    this.dynamicId = id;
  }

  // temporary fixes for cal close
  @HostListener('document:click', ['$event', '$event.target'])
  public onClick(event: MouseEvent, targetElement: HTMLElement) {
    if (!(targetElement.tagName === 'BUTTON'
      || targetElement.tagName === 'I' || targetElement.tagName === 'SELECT'
      || targetElement.tagName === 'SPAN')) {
      let self = this;
      if (self.dynamicId) {
        if (self.dynamicId.isOpen()) {
          setTimeout(function () {
            this.trackHides = null;
          }, 10);
        }
      }
    }
  }

  //delete employee profile page
  public removeImage() {
    this.employeeData.image = null;
    this.employeeData.fileExtension = null;
    this.employeeData.imageUrl = null;
    this.data = {};
    this.isUpdateImage = false;
  }

  //date format in string
  public onDateChange(e) {
    this.employeeData.joiningDate = e.year + '-' + e.month + '-' + e.day;
  }

  //used to resize the image by cropping
  public cropImage($event) {
    this.share.saveData($event);
    let fileExtension = this.getFileExtension($event.target.value);
    this.employeeData.fileExtension = fileExtension[0];

    if ((this.employeeData.fileExtension == 'jpg') || (this.employeeData.fileExtension == 'jpeg') || (this.employeeData.fileExtension == 'png') || (this.employeeData.fileExtension == 'svg') || (this.employeeData.fileExtension == 'svgz')) {
      this.modalService.open(CropImageComponent,
        { windowClass: 'min-modal' }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
          this.isUpdateImage = true;
          this.data = result;

          this.employeeData.image = btoa(result.image.split('base64,')[1]);
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    else {
      this.translate.get('fileUploadFailed').subscribe((msg) => {
        this._toaster.showError(msg);
      });
      return false;
    }

  }

  public getFileExtension(fullPath) {
    let filename = fullPath.replace(/^.*[\\\/]/, '');
    return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename) : undefined;
  }

  public getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public getIdsWithPayload(keyword) {
    let payload = {
      searchString: null,
      excludeEmpIds: []
    };
    payload.searchString = keyword;
    if (this.type === 'EDIT') {
      payload.excludeEmpIds.push(this.employeeId);
    }

    if (this.employeeData.primarySupervisorId) {
      payload.excludeEmpIds.push(this.employeeData.primarySupervisorId);
    }

    if (this.employeeData.verifierId) {
      payload.excludeEmpIds.push(this.employeeData.verifierId);
    }

    if (this.employeeData.secSupervisorIds.length > 0) {
      _.each(this.employeeData.secSupervisorIds, function (key, val) {
        if (!_.isObject(key) && (key != null)) {
          payload.excludeEmpIds.push(key);
        }
      });
    }
    let everythingButTheNulls = _.compact(payload.excludeEmpIds);
    payload.excludeEmpIds = [];
    payload.excludeEmpIds = everythingButTheNulls;
    return payload;
  }

  // ObservableSource
  // to get list of supervisor based on keyword
  public primarySupervisorObservableSource(keyword: any) {
    if (keyword) {
      let url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
      if (keyword.trim()) {
        let payload: any = this.getIdsWithPayload(keyword);
        return this.http.post(url, payload)
          .map((res) => {
            return res;
          }, (error) => {
            console.log(error);
            return Observable.of([]);
          });
      } else {
        return Observable.of([]);
      }
    } else {
      return Observable.of([]);
    }
  }

  // secondarySupervisorObservableSource
  public secondarySupervisorObservableSource(keyword: any) {
    if (keyword) {
      let url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
      if (keyword.trim()) {
        let payload: any = this.getIdsWithPayload(keyword);
        return this.http.post(url, payload)
          .map((res) => {
            return res;
          }, (error) => {
            console.log(error);
            return Observable.of([]);
          });
      } else {
        return Observable.of([]);
      }
    } else {
      return Observable.of([]);
    }
  }

  // To get list of supervisor based on keyword
  public primaryVerifierObservableSource(keyword: any) {
    if (keyword) {
      let url = this._baseUrl + 'v1/webAdmin/employee/supervisorSearch';
      if (keyword.trim()) {
        let payload: any = this.getIdsWithPayload(keyword);
        return this.http.post(url, payload)
          .map((res) => {
            return res;
          }, (error) => {
            console.log(error);
            return Observable.of([]);
          });
      } else {
        return Observable.of([]);
      }
    } else {
      return Observable.of([]);
    }

  }
  // To get list of designation based on keyword
  public designationObservableSource = (keyword: any): Observable<any[]> => {
    if (keyword) {
      let encodedKeyword = encodeURIComponent(keyword);
      let url = this._baseUrl + 'v1/webAdmin/employee/designationSearch';
      url += '?searchString=' + encodedKeyword;
      if (keyword.trim()) {
        return this.http.get(url)
          .map((res) => {
            return res;
          }, (error) => {
            console.log(error);
            return Observable.of([]);
          });
      } else {
        return Observable.of([]);
      }
    } else {
      return Observable.of([]);
    }

  }
  // To get list of grade based on keyword  try{}catch(e){}
  public gradeObservableSource = (keyword: any): Observable<any[]> => {
    if (keyword) {
      let url = this._baseUrl + 'v1/webAdmin/employee/gradeSearch';
      url += '?searchString=' + keyword;
      if (keyword.trim()) {
        return this.http.get(url)
          .map((res) => {
            return res;
          }, (error) => {
            console.log(error);
            return Observable.of([]);
          });
      } else {
        return Observable.of([]);
      }
    } else {
      return Observable.of([]);
    }

  }

  // To get list of category based on keyword
  public categoryObservableSource = (keyword: any): Observable<any[]> => {
    if (keyword) {
      let url = this._baseUrl + 'v1/webAdmin/employee/categorySearch';
      url += '?searchString=' + keyword;
      if (keyword.trim()) {
        return this.http.get(url)
          .map((res) => {
            return res;
          }, (error) => {
            console.log(error);
            return Observable.of([]);
          });
      } else {
        return Observable.of([]);
      }
    } else {
      return Observable.of([]);
    }
  }

  // To get list of managerLevel based on keyword
  public managementLevelObservableSource = (keyword: any): Observable<any[]> => {
    if (keyword) {
      let url = this._baseUrl + 'v1/webAdmin/employee/managerLevelSearch';
      url += '?searchString=' + keyword;
      if (keyword.trim()) {
        return this.http.get(url)
          .map((res) => {
            return res;
          }, (error) => {
            console.log(error);
            return Observable.of([]);
          });
      } else {
        return Observable.of([]);
      }
    } else {
      return Observable.of([]);
    }
  }

  // To get list of Organization based on keyword
  public organizationObservableSource = (keyword: any): Observable<any[]> => {
    if (keyword) {
      let url = this._baseUrl + 'v1/webAdmin/employee/orgSearch';
      url += '?searchString=' + keyword;
      if (keyword.trim()) {
        return this.http.get(url)
          .map((res) => {
            return res;
          }, (error) => {
            console.log(error);
            return Observable.of([]);
          });
      } else {
        return Observable.of([]);
      }
    } else {
      return Observable.of([]);
    }

  }

  // Formatter
  public nameValueFormatter(data: any): string {
    return `${data.name}`;
  }
  public typeValueFormatter(data: any): string {
    return `${data.type}`;
  }
  public orgNameValueFormatter = (data: any): string => {
    let html = `${data.orgName}`;
    return html;
  }

  public autoCompleteListFormatter = (data: any): SafeHtml => {
    let html = `<p class="p-0 m-0">${data.displayName} (${data.empCode})</p><small class="grey-color">${data.email}</small>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
  public autoCompleteListFormatterType = (data: any): SafeHtml => {
    let html = `<span>${data.type}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
  public autoCompleteListNameFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.name}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }
  public autoCompleteListOrgFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.orgName}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  // get employee code
  public generateEmployeeCode() {
    try {
      let url = this._baseUrl + 'v1/webAdmin/employee/generateEmployeeCode';
      this.http.get(url).subscribe((result) => {
        this.employeeData.empCode = result.data;
      });

    } catch (e) {
      console.log('getAllEmployeeData error catch', e);
    }
  }

  public checkLastSecSupervisorIsExists(secSupList): boolean {
    // console.log(secSupList);
    let isSecSupAviable: boolean = true;
    _.each(secSupList, function (sup) {
      if (sup == null) {
        isSecSupAviable = false
      }
    });
    return isSecSupAviable;
  }

  // add secondary supervisor
  public addSecondarySupervisor() {
    if (this.employeeData.primarySupervisorId) {
      if (this.employeeData.secSupervisorIds.length > 4) {
        this.translate.get('maxSupervisor').subscribe((msg) => {
          this._toaster.showError(msg);
        });
      }
      else {
        if (this.checkLastSecSupervisorIsExists(this.employeeData.secSupervisorIds)) {
          this.employeeData.secSupervisorIds.push(null);
          this.secondarySupervisorModel.push(null);
        } else {
          this.translate.get('selectSecondarySupervisor').subscribe((msg) => {
            this._toaster.showError(msg);
          });
        }

      }
    } else {
      this.translate.get('selectPrimarySupervisor').subscribe((msg) => {
        this._toaster.showError(msg);
      });

    }
  }

  // deleting secondary supervisor from UI
  public deleteSecondarySupervisor(e, i) {
    this.employeeData.secSupervisorIds.splice(i, 1);
    this.secondarySupervisorModel.splice(i, 1);
  }

  // navigate back
  public goToBackPage() {
    this._location.back();
  }

  public copyToUsername(e) {
    this.employeeData.userName = e;
  }

  public formatDate(formatDate) {
    if (!formatDate) {
      return;
    }
    let changeDate = formatDate.split('-');
    let formatedDate = {
      year: +changeDate[0],
      month: +changeDate[1],
      day: +changeDate[2]
    };
    this.joiningDate = formatedDate;
    this.onDateChange(this.joiningDate);
  }

  public formatDOBDate(formatDate) {
    if (!formatDate) {
      return;
    }
    let changeDate = formatDate.split('-');
    let formatedDate = {
      year: +changeDate[0],
      month: +changeDate[1],
      day: +changeDate[2]
    };
    this.dateOfBirth = formatedDate;
    this.onDateofBirthChange(this.dateOfBirth);
  }

  // get employee by id
  public getEmployeeById() {
    try {
      let url = this._baseUrl + 'v1/webAdmin/employee/getEmployee'
        + '?employeeId=' + this.employeeId;
      this.http.get(url).subscribe((result) => {
        this.employeeData.id = result.id;
        this.employeeData.empCode = result.empCode;
        this.employeeData.displayName = result.displayName;
        this.employeeData.userName = result.userName;
        this.employeeData.email = result.email;
        this.employeeData.phoneNumber = result.phoneNumber;
        this.employeeData.gender = result.gender;
        this.formatDate(result.joiningDate);
        this.formatDOBDate(result.dateOfBirth);

        if (result.designationName) {
          this.designationModel.name = result.designationName;
          this.designationName = result.designationName;
          this.designationModel.id = result.designationId;
          this.employeeData.designationId = result.designationId;
        }

        if (result.gradeId) {
          this.gradeModel.name = result.gradeName;
          this.gradeModel.id = result.gradeId;
          this.gradeName = result.gradeName;
          this.employeeData.gradeId = result.gradeId;
        }

        if (result.managementLevelId) {
          this.managementModel.name = result.managementLevelName;
          this.managementName = result.managementLevelName;
          this.managementModel.id = result.managementLevelId;
          this.employeeData.managementLevelId = result.managementLevelId;
        }

        if (result.categoryId) {
          this.categoryModel.id = result.categoryId;
          this.categoryModel.type = result.categoryName;
          this.catName = result.categoryName;
          this.employeeData.categoryId = result.categoryId;
        }

        this.employeeData.orgId = result.orgId;
        if (this.type === 'EDIT') {
          this.oldOrgID = result.orgId;
        }
        if (this.type === 'ACTIVATE') {
          this.employeeData.userName = this.employeeData.userName.replace("RESIGN_", "");
          if (result.email) {
            this.employeeData.email = result.email.replace("RESIGN_", "");
          }
          this.employeeData.status = 'ACTIVE';
        }
        this.orgName = result.orgName;
        this.organizationModel = result.orgName;
        //should add this condition to check if value is null or undefined, if not checked it will show null in ngmodel
        if (result.primarySupervisorName) {
          this.primarySupervisorModel.displayName = result.primarySupervisorName;
        }

        //should add this condition to check if value is null or undefined, if not checked it will show null in ngmodel
        if (result.verifierName) {
          this.verifierModel.displayName = result.verifierName;
        }

        this.primarySupervisorModel.id = result.primarySupervisorId;
        this.empdisplayName = result.primarySupervisorName;
        this.employeeData.primarySupervisorId = result.primarySupervisorId;

        this.verDisplayName = result.verifierName;
        this.verifierModel.id = result.verifierId;
        this.employeeData.verifierId = result.verifierId;
        this.employeeData.licenceNumber = result.licenceNumber;
        this.employeeData.userRole = result.userRole;
        let sampleSupIds: any = [];
        let sampleNames: any = [];
        let self = this;
        if (result.secSupData != null && result.secSupData.length > 0) {
          _.each(result.secSupData, function (val, key) {
            sampleSupIds[key] = val.empId;
            sampleNames[key] = val.empName;
          });
          self.employeeData.secSupervisorIds = sampleSupIds;
          self.secondarySupervisorModel = sampleNames;
        }
        if (result.imageUrl == null) {
          this.data = {};
        } else {
          this.employeeData.imageUrl = result.imageUrl;
          this.data.image = true;
        }
        this.oldEmpSupData = result;
        this.loading = false;
      });

    } catch (e) {
      console.log('saveEmployee error caught', e);
    }
  }

  public validateSup() {
    if (this.employeeData.primarySupervisorId == null) {
      if (this.employeeData.verifierId != null) {
        this.translate.get('pleaseSelectSupervisor').subscribe((msg) => {
          this._toaster.showError(msg);
        });
        return false;
      } else if (_.isArray(this.employeeData.secSupervisorIds)
        && this.employeeData.secSupervisorIds.length > 0) {
        if (this.employeeData.secSupervisorIds[0] != null) {
          this.translate.get('pleaseSelectSupervisor').subscribe((msg) => {
            this._toaster.showError(msg);
          });
          return false;
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  // save employee
  public saveEmployeeData() {
    try {
      let that = this;
      if (this.validateSup()) {
        let data: any = that.employeeData;
        if (data.orgId == null) {
          this.translate.get('pleaseSelectOrgUnit').subscribe((msg) => {
            this._toaster.showError(msg);
          });
          return;
        }
        if (this.joiningDate == null) {
          this.translate.get('pleaseSelectDateOfHire').subscribe((msg) => {
            this._toaster.showError(msg);
          });
          return;
        }
        that.saveEmpData();
      }
    } catch (e) {
      console.log('saveEmployee error caught', e);
    }
  }

  public saveEmpData() {
    try {
      let self = this;
      self.showButtonLoading = true;
      let url = self._baseUrl + 'v1/webAdmin/employee/saveEmployee';
      // remove all null values
      let data = self.employeeData;
      _.map(data, function (val, key) {
        if (_.isArray(val)) { if (_.isEmpty(val)) { delete data[key]; } }
        if (val == null) { delete data[key]; }
      });
      self.http.post(url, data).subscribe((result) => {
        if (result.success) {
          if (_.isArray(result.data)) {
            self.showButtonLoading = false;
            setTimeout(() => this.goToBackPage(), 3000)
          } else {
            setTimeout(() => this.goToBackPage(), 1000);
            if (self.type === 'EDIT') {
              self.translate.get('empUpdated').subscribe((msg) => {
                self._toaster.showSuccess(msg);
              });
            } else if (self.type === 'ACTIVATE') {
              self.translate.get('empActivated').subscribe((msg) => {
                self._toaster.showSuccess(msg);
              });
            } else {
              self.translate.get('empSaved').subscribe((msg) => {
                self._toaster.showSuccess(msg);
              });
            }
          }

        } else {
          self.showButtonLoading = false;
          _.each(result.data, function (element) {
            self.translate.get(element).subscribe((msg) => {
              self._toaster.showError(msg);
            })
          })
        }
      });
    } catch (e) {
      console.log('saveEmployee error caught', e);
    }
  }

  public validateEmpSupRelationChange() {
    let self = this;
    let flag: boolean = false;
    if (self.oldEmpSupData.primarySupervisorId !== self.employeeData.primarySupervisorId) {
      flag = true;
    } else if (self.oldEmpSupData.verifierId !== this.employeeData.verifierId) {
      flag = true;
    } else if (_.isArray(self.employeeData.secSupervisorIds) &&
      _.isArray(self.oldEmpSupData.secSupData)) {
      if (self.employeeData.secSupervisorIds.length === self.oldEmpSupData.secSupData.length) {
        _.each(self.employeeData.secSupervisorIds, function (val) {
          const index: number = self.employeeData.secSupervisorIds.indexOf(val);
          if (val !== self.oldEmpSupData.secSupData[index].empId) {
            flag = true;
          }
        });
      } else {
        flag = true;
      }
    } else {
      flag = false;
    }
    return flag;
  }

  public supChange(e) {
    this.empdisplayName = e.target.value;
  }

  public supSelected() {
    if (!this.empdisplayName) {
      this.primarySupervisorModel = {
        id: null,
        displayName: ''
      };
      this.employeeData.primarySupervisorId = null;
    } else {
      this.employeeData.primarySupervisorId = this.primarySupervisorModel.id;
    }
  }

  public verifierChange(e) {
    this.verDisplayName = e.target.value;
  }

  public verifierSelected() {
    if (this.verDisplayName === '') {
      this.verifierModel = {
        id: null,
        displayName: ''
      };
      this.employeeData.verifierId = null;
    } else {
      this.employeeData.verifierId = this.verifierModel.id;
    }
  }

  public secSupChange(e) {
    this.secSupDisplayName = e.target.value;
  }

  public secSupSelected(i: number) {
    if (this.secSupDisplayName === '') {
      this.secondarySupervisorModel.splice(i, 1);
      this.employeeData.secSupervisorIds.splice(i, 1);
    } else {
      if (this.secSupDisplayName != null) {
        if (this.secondarySupervisorModel[i].id) {
          this.employeeData.secSupervisorIds[i] = this.secondarySupervisorModel[i].id;
        }
      }
    }
  }

  public empTypeChange(e) {
    this.catName = e.target.value;
  }

  public empTypeSelected() {
    if (this.catName === '') {
      this.categoryModel = {
        id: null,
        type: ''
      };
      this.employeeData.categoryId = null;
    } else {
      this.employeeData.categoryId = this.categoryModel.id;
    }
  }

  public categoryTypeChange(e) {
    this.managementName = e.target.value;
  }

  public categoryTypeSelected() {
    if (this.managementName === '') {
      this.managementModel = {
        id: null,
        name: ''
      };
      this.employeeData.managementLevelId = null;
    } else {
      this.employeeData.managementLevelId = this.managementModel.id;
    }
  }

  public designationChange(e) {
    this.designationName = e.target.value;
  }

  public designationSelected() {
    if (this.designationName === '') {
      this.designationModel = {
        id: null,
        name: ''
      };
      this.employeeData.designationId = null;
    } else {
      this.employeeData.designationId = this.designationModel.id;

    }
  }

  public gradeChange(e) {
    this.gradeName = e.target.value;
  }

  public gradeSelected() {
    if (this.gradeName === '') {
      this.gradeModel = {
        id: null,
        name: ''
      };
      this.employeeData.gradeId = null;
    } else {
      this.employeeData.gradeId = this.gradeModel.id;
    }
  }
  public orgChange(e) {
    this.orgName = e.target.value;
    this.orgFormData = this.orgName;
  }
  public orgSelected() {
    if (this.orgName === '') {
      this.organizationModel = {
        id: null,
        orgName: ''
      };
      this.disableSave = true;
      this.employeeData.orgId = null;
    } else {
      this.disableSave = false;
      this.employeeData.orgId = this.organizationModel.id ? this.organizationModel.id : this.employeeData.orgId;
      this.orgFormData = this.employeeData.orgId;
    }
  }

  public onDateofBirthChange(e) {
    this.employeeData.dateOfBirth = e.year + '-' + e.month + '-' + e.day;
  }

  public getRoleLabel(value) {
    switch (value) {
        case 'ROLE_USER':
            return 'User';
        case 'ROLE_VACCINE_ADMIN':
            return 'Vaccine Admin';
        case 'ROLE_VACCINE_SEARCH_ADMIN':
            return 'Vaccine Search';
        case 'ROLE_LAB_ADMIN':
            return 'Lab Admin';
        case 'ROLE_TRACE_HUB_ADMIN':
            return 'TraceHub';
        default:
            return 'None';
    }
}

  // public setRole(value) {
  //   this.employeeData.userRole = value;
  // }

  // public getRoleLabel(value) {
  //   switch (value) {
  //     case 'ROLE_USER':
  //       return 'User';
  //     case 'ROLE_VACCINE_ADMIN':
  //       return 'Vaccine Admin';
  //     case 'ROLE_VACCINE_SEARCH_ADMIN':
  //       return 'Vaccine Search';
  //     case 'ROLE_LAB_ADMIN':
  //       return 'Lab Admin';
  //     case 'ROLE_TRACE_HUB_ADMIN':
  //       return 'TraceHub Admin';
  //     case 'ROLE_ADMIN':
  //       return 'Administrator';
  //     default:
  //       return 'None';
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/app/employee/addEmployees.ts